import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';

// Add a language here (and its JSON file) to make it selectable everywhere.
export const SUPPORTED_LANGUAGES = ['en', 'es'];
export const DEFAULT_LANGUAGE = 'en';

// Right-to-left languages, kept here so the layout can flip when one is added.
const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];
export const getDirection = (lng) =>
  RTL_LANGUAGES.includes((lng || '').split('-')[0]) ? 'rtl' : 'ltr';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: DEFAULT_LANGUAGE,
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'careascension.lang',
      caches: ['localStorage'],
    },
    returnObjects: true,
  });

export default i18n;
